<template>
  <nav
    class="shadow-none navbar navbar-main navbar-expand-lg border-radius-xl"
    id="navbarBlur"
    data-scroll="true"
    :style="navOffsetStyle"
  >
    <!-- 양끝 정렬: 왼쪽(햄버거) / 오른쪽(설정) -->
    <div class="px-4 py-2 container-fluid d-flex align-items-center justify-content-between">
      <!-- 왼쪽: 사이드내브 토글 -->
      <a
        href="#"
        class="p-0 nav-link text-body"
        id="iconNavbarSidenav"
        @click.prevent="toggleSidenav"
        aria-label="Toggle sidenav"
      >
        <div class="sidenav-toggler-inner" style="cursor:pointer">
          <i class="sidenav-toggler-line"></i>
          <i class="sidenav-toggler-line"></i>
          <i class="sidenav-toggler-line"></i>
        </div>
      </a>

      <!-- 오른쪽: 설정 드롭다운 -->
      <ul class="navbar-nav d-flex align-items-center mb-0">
        <!-- 도움/가이드 버튼 -->
        <li class="nav-item d-flex align-items-center me-3">
          <a
            href="#"
            class="p-0 nav-link"
            :class="textWhite ? textWhite : 'text-body'"
            aria-label="Open help guide"
            title="도움말"
            @click.prevent="emitHelp"
          >
            <i class="fa fa-question-circle fs-4"></i>
          </a>
        </li>
        <li class="nav-item dropdown d-flex align-items-center" ref="dropdown">
          <a
            href="#"
            class="p-0 nav-link"
            :class="[ textWhite ? textWhite : 'text-body', showMenu ? 'show' : '' ]"
            id="dropdownMenuButton"
            aria-expanded="false"
            @click.prevent="showMenu = !showMenu"
          >
            <i class="cursor-pointer fa fa-cog fixed-plugin-button-nav fs-4"></i>
          </a>
          <ul
            class="px-2 py-3 dropdown-menu dropdown-menu-end me-2 custom-wide"
            :class="showMenu ? 'show' : ''"                      
            aria-labelledby="dropdownMenuButton"
          >
            <li class="mb-2">
              <div class="border-radius-md py-0 px-3" style="cursor: default;">
                <div class="py-1 d-flex">
                  <div class="my-auto">
                    <div class="avatar-frame avatar-sm me-2">
                      <img
                        v-if="userInfo?.imageUrl"
                        :src="userInfo?.imageUrl"
                        class="avatar-img rounded-3"
                        alt="profile"
                      />
                      <img
                        v-else 
                        src="../../assets/img/user/default.png"
                        class="avatar-img rounded-3"
                        alt="profile"
                      />
                    </div>
                  </div>
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm font-weight-normal text-nowrap">
                      <span class="font-weight-bold">{{ userInfo?.name }}</span> 님
                    </h6>
                    <small class="text-xs text-secondary">{{ userInfo?.groupDc }}</small>
                  </div>
                </div>
              </div>
            </li>
            <li><hr class="dropdown-divider my-1" /></li>
            <li>
              <div class="dropdown-item border-radius-md mt-2" @click="myProfile">
                <div class="py-1 d-flex">
                  <div class="my-auto font-weight-bold">
                    프로필 수정
                  </div>
                </div>
              </div>
            </li>
            <!-- <li>
              <div class="dropdown-item border-radius-md" @click="selMf">
                <div class="py-1 d-flex">
                  <div class="my-auto font-weight-bold">
                    제조사 선택
                  </div>
                </div>
              </div>
            </li> -->
            <li>
              <div class="dropdown-item border-radius-md" @click="logout">
                <div class="py-1 d-flex">
                  <div class="my-auto font-weight-bold">
                    로그아웃
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import api from '@/api/api'
import { mapMutations } from 'vuex'

export default {
  name: 'navbar',
  props: ['minNav', 'textWhite'],
  emits: ['open-help'],
  inject: ['showLoading', 'hideLoading'],
  data() {
    return {
      showMenu: false,
      // 사이드내브 폭 (접힘/펼침에 맞게 수정해서 쓰면 됨)
      sidenavWidth: 250,
      miniSidenavWidth: 120,
      isMini: false,
      vw: window.innerWidth,
    }
  },
  computed: {
    // ✅ 반응형으로 모바일 판별
    isMobile() { return this.vw < 1200 },

    isRTL() { return this.$store.state.isRTL; },

    // ✅ 오프셋도 반응형 기준값 사용
    navOffsetStyle() {
      const desktop = !this.isMobile
      const base = this.isMini ? this.miniSidenavWidth : this.sidenavWidth
      const offset = desktop ? `${base}px` : '0px'
      return this.isRTL ? { paddingRight: offset } : { paddingLeft: offset }
    },
  },
  mounted() {
    window.addEventListener('click', this.handleOutsideClick)
    window.addEventListener('resize', this.handleResize, { passive: true })
  },
  beforeUnmount() {
    window.removeEventListener('click', this.handleOutsideClick)
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapMutations(['navbarMinimize', 'setShowSidenav']),
    handleResize() {
      this.vw = window.innerWidth
      // 강제 리렌더로 padding 계산 재적용
      this.$forceUpdate()
    },
    handleOutsideClick(e) {
      const dropdown = this.$refs.dropdown
      if (dropdown && !dropdown.contains(e.target)) this.showMenu = false
    },
    toggleSidenav() {
      if (this.isMobile) {
        this.setShowSidenav(true)         // 모바일: 사이드네비 열기 (오버레이는 App.vue에서)
        return
      }
      this.isMini = !this.isMini
      document.body.classList.toggle('g-sidenav-mini', this.isMini)
      // 데스크톱: 미니 토글(기존 로직 유지)
      this.navbarMinimize()
      // isMini 상태 업데이트(선택) — 필요하면 클래스/스토어 보고 동기화
      const root = document.querySelector('.g-sidenav-show')
      this.isMini = root?.classList.contains('g-sidenav-hidden') || false
      this.$forceUpdate();
    },
    async logout() {
      this.showMenu = false;
      this.showLoading('로그아웃중...')
      try {
        const delay = ms => new Promise(r => setTimeout(r, ms))
        const [res] = await Promise.all([api.get('/auth/logout'), delay(600)])
        if (res.data.resultCode == '200') {
          this.$store.commit('UserStore/clearAuth')
          this.toastSuccess('로그아웃 되었습니다.')
          this.$router.push('/sign-in')
        } else {
          this.toastError(res.data.resultMessage)
        }
      } catch (e) {
        console.error(e)
        this.toastError('서버 오류로 로그아웃에 실패했습니다.')
      } finally {
        this.hideLoading();
      }
    },
    myProfile(){
      this.showMenu = false;
      this.$router.push({ name: 'Profile', params: { id: this.userInfo?.id } })
    },
    selMf(){
      this.showMenu = false;
      this.$router.push({ name: 'SelMf' })
    },
    emitHelp() {
      this.showMenu = false;
      this.$emit('open-help');
    },
  },
}
</script>

<style scoped>
@media (min-width: 768px) {
  .dropdown-menu.custom-wide { min-width: 200px !important; }
}

.avatar-frame {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
  border: 1px solid rgba(0,0,0,.08);
  overflow: hidden;
}

.avatar-sm {
  width: 36px;
  height: 36px;
  border-radius: 0.5rem;
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-fallback {
  font-size: 0.7rem;
  color: #9ca3af;
}
</style>
